export default __webpack_public_path__ + "static/media/95t.91ca7e55.jpg";